/**
 * @file  routes/index.ts
 * @description  renew router component
 *
 * @author ogarcia (ozkary)
 *
 */
import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import pageLoader from '../../routes/pageLoader';
import routes, { baseRoutes } from './config';

/**
 * router management component to manage the application level routes
 *
 */
const Router = (): JSX.Element => {
  return (
    <Switch>
      {routes.map((routeItem) => {
        return (
          <Route
            key={routeItem.component}
            path={routeItem.path}
            exact={routeItem.exact}
            component={lazy(() => pageLoader(() => import(`../../vsc/containers/${routeItem.component}`))
            )}
          />
        );
      })}

      {baseRoutes.map((routeItem) => {
        return (
          <Route
            key={routeItem.component}
            path={routeItem.path}
            exact={routeItem.exact}
            component={lazy(() => pageLoader(() => import(`../../containers${routeItem.component}`))
            )}
          />
        );
      })}
    </Switch>
  );
};

export default Router;
